import { useMemo } from "react";
import { S3_URL } from "commons/config";
import { useConfig } from "context/configContext";
import { getAppConfig } from "commons/util/appConfigHelper";

export const useImageList = () => {
  const { appConfig } = useConfig();

  const platform = getAppConfig("platform");

  const fetchImageList = (commonBaseURL, locationBaseURL) => {
    return {
      arrows: {
        arrowRightGreen: `${commonBaseURL}/arrows/arrowRightGreen.svg`,
        arrowUpGreen: `${commonBaseURL}/arrows/arrowUpGreen.svg`,
        backArrow: `${commonBaseURL}/arrows/backArrow.svg`,
        backArrowBlack: `${commonBaseURL}/arrows/backArrowBlack.svg`,
        chevronDown: `${commonBaseURL}/arrows/chevron_down.svg`,
      },
      addFlightModal: {
        dateIcon: `${commonBaseURL}/addFlightModal/dateIcon.svg`,
        fromFlightIcon: `${commonBaseURL}/addFlightModal/fromFlightIcon.svg`,
        toFlightIcon: `${commonBaseURL}/addFlightModal/toFlightIcon.svg`,
      },
      addNewFlight: {
        alert_no_flights: `${commonBaseURL}/addNewFlight/alert_no_flights.svg`,
        arrowBigDown: `${commonBaseURL}/addNewFlight/arrowBigDown.svg`,
        calendarSmall: `${commonBaseURL}/addNewFlight/calendarSmall.svg`,
        chek: `${commonBaseURL}/addNewFlight/chek.svg`,
        departureSmall: `${commonBaseURL}/addNewFlight/departureSmall.svg`,
        group: `${commonBaseURL}/addNewFlight/group.svg`,
        iconChangeDisabled: `${commonBaseURL}/addNewFlight/iconChangeDisabled.svg`,
        iconChangeEnabled: `${commonBaseURL}/addNewFlight/iconChangeEnabled.svg`,
        iconClose: `${commonBaseURL}/addNewFlight/iconClose.svg`,
        locationSmall: `${commonBaseURL}/addNewFlight/locationSmall.svg`,
        plusWhite: `${commonBaseURL}/addNewFlight/plusWhite.svg`,
        swapArrow: `${commonBaseURL}/addNewFlight/swapArrow.svg`,
        timeSmall: `${commonBaseURL}/addNewFlight/timeSmall.svg`,
      },
      bottomNav: {
        foodFilled: `${commonBaseURL}/bottomNav/food-filled.svg`,
        foodOutlined: `${commonBaseURL}/bottomNav/food-outlined.svg`,
        homeFilled: `${commonBaseURL}/bottomNav/home-filled.svg`,
        homeOutlined: `${commonBaseURL}/bottomNav/home-outlined.svg`,
        menuFilled: `${commonBaseURL}/bottomNav/menu-filled.svg`,
        menuOutlined: `${commonBaseURL}/bottomNav/menu-outlined.svg`,
        mytripsFilled: `${commonBaseURL}/bottomNav/mytrips-filled.svg`,
        mytripsOutlined: `${commonBaseURL}/bottomNav/mytrips-outlined.svg`,
        orderFilled: `${commonBaseURL}/bottomNav/order-filled.svg`,
        orderOutlined: `${commonBaseURL}/bottomNav/order-outlined.svg`,
        payBillFilled: `${commonBaseURL}/bottomNav/payBill-filled.svg`,
        payBillOutlined: `${commonBaseURL}/bottomNav/payBill-outlined.svg`,
        profileFilled: `${commonBaseURL}/bottomNav/profile-filled.svg`,
        profileOutlined: `${commonBaseURL}/bottomNav/profile-outlined.svg`,
        rewardsFilled: `${commonBaseURL}/bottomNav/rewards-filled.svg`,
        rewardsOutlined: `${commonBaseURL}/bottomNav/rewards-outlined.svg`,
        servicesFilled: `${commonBaseURL}/bottomNav/services-filled.svg`,
        servicesOutlined: `${commonBaseURL}/bottomNav/services-outlined.svg`,
        transportFilled: `${commonBaseURL}/bottomNav/transport-filled.svg`,
        transportOutlined: `${commonBaseURL}/bottomNav/transport-outlined.svg`,
      },
      cart: {
        arrowRightBlack: `${commonBaseURL}/cart/arrowRightBlack.svg`,
        arrowUpBlack: `${commonBaseURL}/cart/arrowUpBlack.svg`,
        closeIcon: `${commonBaseURL}/cart/closeIcon.svg`,
        couponIcon: `${commonBaseURL}/cart/couponIcon.svg`,
        decreaseQty: `${commonBaseURL}/cart/decrease-qty.svg`,
        discountIcon: `${commonBaseURL}/cart/discount_icon.svg`,
        emptyCart: `${commonBaseURL}/cart/empty-cart.svg`,
        increaseQty: `${commonBaseURL}/cart/increase-qty.svg`,
        infoIcon: `${commonBaseURL}/cart/Minus.svg`,
        Minus: `${commonBaseURL}/cart/transport-outlined.svg`,
        noBillToPay: `${commonBaseURL}/cart/no-bill-to-pay.svg`,
        Plus: `${commonBaseURL}/cart/Plus.svg`,
        tagIcon: `${locationBaseURL}/cart/tag-icon.svg`,
        discountAppliedIcon: `${commonBaseURL}/cart/discount-applied-icon.svg`,
      },
      couponListing: {
        illustrationImage: `${commonBaseURL}/couponListing/illustrationImage.svg`,
        noCoupons: `${commonBaseURL}/couponListing/noCoupons.png`,
      },
      csr: {
        donateNow: `${commonBaseURL}/csr/donateNow.jpg`,
      },
      flights: {
        airlineIcon: `${commonBaseURL}/flights/airline_icon.svg`,
        airlinePath: `${commonBaseURL}/flights/airline_path.svg`,
        crossRed: `${commonBaseURL}/flights/cross_red.svg`,
        flightStatus: `${commonBaseURL}/flights/flight-status.svg`,
      },
      heroBanner: {
        CovFAQ: `${commonBaseURL}/heroBanner/CovFAQ.png`,
      },
      home: {
        Airplane: `${commonBaseURL}/home/flightCard/Airplane.svg`,
      },
      indoorBgImages: {
        indoorLanternRightDesktop: `${commonBaseURL}/indoorBgImages/indoor-lantern-right-desktop.svg`,
        indoorLanternRightMobile: `${commonBaseURL}/indoorBgImages/indoor-lantern-right-mobile.svg`,
      },
      LargeActionButton: `${commonBaseURL}/LargeActionButton`,
      orderRecovery: {
        declinedCard: `${commonBaseURL}/orderRecovery/declined-card.svg`,
        exclamation: `${commonBaseURL}/orderRecovery/exclamation.svg`,
        modifierUnavailable: `${commonBaseURL}/orderRecovery/modifier-unavailable.svg`,
        priceChange: `${commonBaseURL}/orderRecovery/price-change.svg`,
        orderCancelled: `${commonBaseURL}/orderRecovery/order-cancelled.svg`,
        unavailable: `${commonBaseURL}/orderRecovery/unavailable.svg`,
        posDownClipboard: `${commonBaseURL}/orderRecovery/pos-down-clipboard.svg`,
      },
      paymentFail: {
        paymentFail: `${commonBaseURL}/paymentFail/payment-fail.svg`,
      },
      paymentSuccess: {
        close: `${commonBaseURL}/paymentSuccess/close.svg`,
        orderConfirmed: `${commonBaseURL}/order_confirmed.gif`,
      },
      quickSignIn: {
        OtpVerified: `${commonBaseURL}/quickSignIn/OtpVerified.svg`,
      },
      searchResult: {
        defaultImage: `${commonBaseURL}/searchResult/defaultImage.svg`,
        noResults: `${commonBaseURL}/searchResult/noResults.svg`,
      },
      shops: {
        FoundedInPhillyLogo: `${commonBaseURL}/shops/FoundedInPhilly_Logo.svg`,
      },
      signIn: {
        arrowLeft: `${commonBaseURL}/signIn/arrow-left.svg`,
        signUp: `${commonBaseURL}/signIn/Sign-up03.jpg`,
      },
      takeaway: {
        ScheduleOrderMeal: `${commonBaseURL}/takeaway/ScheduleOrderMeal.svg`,
      },
      terminalTwo: {
        backArrow: `${commonBaseURL}/terminalTwo/backArrow.svg`,
      },
      header: {
        cart: `${locationBaseURL}/header/cart.svg`,
        ChevronDown: `${commonBaseURL}/header/ChevronDown.svg`,
        hamburgerIcon: `${locationBaseURL}/header/hamburgerIcon.svg`,
        profilePhoto: `${commonBaseURL}/header/Profile-photo.svg`,
        search: `${commonBaseURL}/header/search.png`,
        user: `${locationBaseURL}/header/user.svg`,
        close: `${commonBaseURL}/header/hamburger/close.svg`,
        downArrow: `${commonBaseURL}/header/hamburger/down-arrow.svg`,
        upArrow: `${commonBaseURL}/header/hamburger/up-arrow.svg`,
      },
      profile: {
        arrowRight: `${commonBaseURL}/profile/arrowRight.svg`,
        arrowRightUser: `${commonBaseURL}/profile/arrow-right.svg`,
        arrowRightBlack: `${commonBaseURL}/profile/ArrowRightBlack.svg`,
        closeIcon: `${commonBaseURL}/profile/close-icon.svg`,
        customerSupport: `${commonBaseURL}/profile/customerSupport.svg`,
        editIcon: `${commonBaseURL}/profile/editIcon.svg`,
        employeeIcon: `${commonBaseURL}/profile/employeeIcon.svg`,
        employeeLoginSuccess: `${commonBaseURL}/profile/employeeLoginSuccess.svg`,
        feedbackIcon: `${commonBaseURL}/profile/feedbackIcon.svg`,
        logoutIcon: `${commonBaseURL}/profile/logoutIcon.svg`,
        myOrdersIcon: `${commonBaseURL}/profile/myOrdersIcon.svg`,
        rightArrowGreen: `${commonBaseURL}/profile/rightArrowGreen.svg`,
        settingsIcon: `${commonBaseURL}/profile/settingsIcon.svg`,
        time: `${commonBaseURL}/profile/time.svg`,
        TravellerProfile: `${commonBaseURL}/profile/Traveller-Profile-500.jpg`,
        TravellerProfileMobile: `${commonBaseURL}/profile/Traveller-Profile-Mobile.jpg`,
      },
      commons: {
        errorIcon: `${commonBaseURL}/commons/error_icon.svg`,
        filterIconBlack: `${commonBaseURL}/commons/filterIconBlack.svg`,
        minusBlue: `${commonBaseURL}/commons/minus_blue.svg`,
        minusWhite: `${commonBaseURL}/commons/minus_white.svg`,
        plusBlue: `${commonBaseURL}/commons/plus_blue.svg`,
        plusWhite: `${commonBaseURL}/commons/plus_white.svg`,
        smartphoneApprove: `${commonBaseURL}/commons/smartphoneApprove.svg`,
        searchGray: `${commonBaseURL}/commons/searchGray.svg`,
        iconBlack: `${commonBaseURL}/commons/x-icon-black.svg`,
        iconGray: `${commonBaseURL}/commons/x-icon-gray.svg`,
        airplaneIcon: `${commonBaseURL}/commons/airplaneIcon.svg`,
        alertCross: `${commonBaseURL}/commons/alertCross.png`,
        Directions: `${commonBaseURL}/commons/Directions.svg`,
        envelopeClosedBlack: `${commonBaseURL}/commons/envelope-closed-black.svg`,
        google: `${commonBaseURL}/commons/google.svg`,
        imageClose: `${commonBaseURL}/commons/image_close.svg`,
        phoneHeadsetBlack: `${commonBaseURL}/commons/phone-headset-black.svg`,
        takemethere: `${commonBaseURL}/commons/takemethere.svg`,
        twitterLogin: `${commonBaseURL}/commons/twitter-login.svg`,
        upload: `${commonBaseURL}/commons/upload.png`,
        plusBlack: `${commonBaseURL}/commons/plus_black.svg`,
        minusBlack: `${commonBaseURL}/commons/minus_black.svg`,
      },
      pages: {
        cart: {
          Cooking: `${commonBaseURL}/pages/cart/Cooking.svg`,
          infoIcon: `${commonBaseURL}/pages/cart/infoIcon.svg`,
          swipeToPaySlider: `${commonBaseURL}/pages/cart/swipe-to-pay-slider.svg`,
          successIcon: `${commonBaseURL}/pages/cart/successIcon.svg`,
        },
        chatBot: {
          arrorRight: `${commonBaseURL}/pages/cart/arrorRight.png`,
          arrowsRefactored: `${commonBaseURL}/pages/cart/arrows-refactored.png`,
          BnglrAirport: `${commonBaseURL}/pages/cart/BnglrAirport.jpg`,
          closebtn: `${commonBaseURL}/pages/cart/closebtn.svg`,
          fly: `${commonBaseURL}/pages/cart/fly.png`,
          robotIcon: `${commonBaseURL}/pages/cart/robotIcon.png`,
          sendIcon: `${commonBaseURL}/pages/cart/sendIcon.png`,
        },
        dineIn: {
          backgroundImage: `${commonBaseURL}/pages/dineIn/backgroundImage.png`,
          exclamation: `${commonBaseURL}/pages/dineIn/exclamation.svg`,
          GreenTick: `${commonBaseURL}/pages/dineIn/GreenTick.svg`,
          invoiceIcon: `${commonBaseURL}/pages/dineIn/invoiceIcon.svg`,
          rightArrow: `${commonBaseURL}/pages/dineIn/rightArrow.svg`,
        },
        edpDutyFree: {
          entryImage: `${commonBaseURL}/pages/edpDutyFree/entry-image.png`,
        },
        HelpAndSupport: {
          videoIcon: `${commonBaseURL}/pages/HelpAndSupport/videoIcon.png`,
        },
        laxHomepage: {
          iconClose: `${commonBaseURL}/pages/laxHomepage/iconClose.svg`,
          orderNow: `${commonBaseURL}/pages/laxHomepage/orderNow.svg`,
          searchIconBlack: `${commonBaseURL}/pages/laxHomepage/searchIconBlack.svg`,
        },
        MyBookings: {
          closeIcon: `${commonBaseURL}/pages/MyBookings/x.svg`,
          confirmationMailIcon: `${commonBaseURL}/pages/MyBookings/confirmationMail.svg`,
          delToGateIcon: `${commonBaseURL}/pages/MyBookings/del_to_gate_icon.svg`,
          invoice: `${commonBaseURL}/pages/MyBookings/invoice.png`,
          noActiveOrders: `${commonBaseURL}/pages/MyBookings/no-active-orders.svg`,
          noPastBooking: `${commonBaseURL}/pages/MyBookings/no-past-orders.svg`,
          pickUpAtStoreIcon: `${commonBaseURL}/pages/MyBookings/pickup_from_store_icon.svg`,
          qrIcon: `${commonBaseURL}/pages/MyBookings/qr-icon.svg`,
          raiseIssueIcon: `${commonBaseURL}/pages/MyBookings/raiseIssueIcon.svg`,
          rightArrowGreen: `${commonBaseURL}/pages/MyBookings/rightArrowGreen.svg`,
        },
        myRaffles: {
          raffle: `${commonBaseURL}/pages/myRaffles/raffle.svg`,
        },
        personalDetails: {
          illustrationLeft: `${commonBaseURL}/pages/personalDetails/illustrationLeft.svg`,
          illustrationRight: `${commonBaseURL}/pages/personalDetails/illustrationRight.svg`,
        },
        edpFSTR: {
          addFlightIllustration: `${commonBaseURL}/pages/edpFSTR/addFlightIllustration.svg`,
          arrowLeft: `${commonBaseURL}/pages/edpFSTR/arrowLeft.svg`,
          backArrow: `${commonBaseURL}/pages/edpFSTR/BackArrow.svg`,
          cancelPrompt: `${commonBaseURL}/pages/edpFSTR/cancel_prompt.svg`,
          cancelBlack: `${commonBaseURL}/pages/edpFSTR/CancelBlack.svg`,
          carouselLeft: `${commonBaseURL}/pages/edpFSTR/CarouselLeft.svg`,
          carouselRight: `${commonBaseURL}/pages/edpFSTR/CarouselRight.svg`,
          departureBlack: `${commonBaseURL}/pages/edpFSTR/DepartureBlack.svg`,
          directoryHeroBg: `${commonBaseURL}/pages/edpFSTR/directory-hero-bg.svg`,
          downArrow: `${commonBaseURL}/pages/edpFSTR/DownArrow.svg`,
          dropDownIcon: `${commonBaseURL}/pages/edpFSTR/DropDownIcon.svg`,
          editIcon: `${commonBaseURL}/pages/edpFSTR/EditIcon.svg`,
          ETA: `${commonBaseURL}/pages/edpFSTR/ETA.svg`,
          ETABlack: `${commonBaseURL}/pages/edpFSTR/ETABlack.svg`,
          filterIcon: `${commonBaseURL}/pages/edpFSTR/filterIcon.svg`,
          forward: `${commonBaseURL}/pages/edpFSTR/Forward.svg`,
          greyTickIcon: `${commonBaseURL}/pages/edpFSTR/greyTickIcon.svg`,
          info: `${commonBaseURL}/pages/edpFSTR/info.svg`,
          inspectionReport: `${commonBaseURL}/pages/edpFSTR/InspectionReport.gif`,
          locateIcon: `${commonBaseURL}/pages/edpFSTR/LocateIcon.svg`,
          locateIconBlack: `${commonBaseURL}/pages/edpFSTR/LocateIconBlack.svg`,
          menuIconHover: `${commonBaseURL}/pages/edpFSTR/MenuIconHover.svg`,
          menuIconPrimary: `${commonBaseURL}/pages/edpFSTR/MenuIconPrimary.svg`,
          phoneCall: `${commonBaseURL}/pages/edpFSTR/phone-call.svg`,
          pinkGradient: `${commonBaseURL}/pages/edpFSTR/Pink-Gradient.png`,
          prepTime: `${commonBaseURL}/pages/edpFSTR/pretime.svg`,
          rating: `${commonBaseURL}/pages/edpFSTR/Rating.svg`,
          scheduleLaterIcon: `${commonBaseURL}/pages/edpFSTR/ScheduleLaterIcon.svg`,
          tealGradient: `${commonBaseURL}/pages/edpFSTR/Teal-Gradient.png`,
          timer: `${commonBaseURL}/pages/edpFSTR/timer.svg`,
          viewAll: `${commonBaseURL}/pages/edpFSTR/viewAll.svg`,
          closeIconGreen: `${commonBaseURL}/pages/edpFSTR/xIconGreen.svg`,
          productFallbackLarge: `${commonBaseURL}/pages/edpFSTR/Fallback Images/product-fallback-large.svg`,
          productFallbackMedium: `${commonBaseURL}/pages/edpFSTR/Fallback Images/product-fallback-medium.svg`,
          productFallbackSmall: `${commonBaseURL}/pages/edpFSTR/Fallback Images/product-fallback-small.svg`,
        },
      },
      BottomDrawer: {
        cross: `${commonBaseURL}/BottomDrawer/cross.svg`,
        crossWithBackground: `${commonBaseURL}/BottomDrawer/crossWithBackground.svg`,
      },
      socialSharing: {
        closeIcon: `${commonBaseURL}/socialSharing/closeIcon.svg`,
        copyIcon: `${commonBaseURL}/socialSharing/copyIcon.svg`,
        fbIcon: `${commonBaseURL}/socialSharing/fbIcon.svg`,
        linkedinIcon: `${commonBaseURL}/socialSharing/linkedinIcon.svg`,
        twitterIcon: `${commonBaseURL}/socialSharing/twitterIcon.svg`,
        whatsappIcon: `${commonBaseURL}/socialSharing/whatsappIcon.svg`,
      },
      verifyOtp: {
        arrowLeft: `${commonBaseURL}/verifyOtp/arrow-left.svg`,
      },
      DesktopDateTimePicker: {
        calendar: `${commonBaseURL}/DesktopDateTimePicker/calendar.svg`,
      },
      Dropdown: {
        dropdownDownArrowBlack: `${commonBaseURL}/Dropdown/dropdownDownArrowBlack.svg`,
        dropdownDownArrowWhite: `${commonBaseURL}/Dropdown/dropdownDownArrowWhite.svg`,
      },
      galleryCarousal: {
        arrowRight: `${commonBaseURL}/galleryCarousal/arrowRight.svg`,
      },
      closeIcon: `${locationBaseURL}/close-icon.svg`,
      MenuIconPrimary: `${locationBaseURL}/MenuIconPrimary.svg`,
      NoResultFound: `${locationBaseURL}/NoResultFound.svg`,
      viewAll: `${locationBaseURL}/viewAll.svg`,
      orderConfirmed: `${locationBaseURL}/OrderConfirmedIcon.json`,
      Directory: {
        closeIcon: `${locationBaseURL}/directory/closeIcon.svg`,
      },
      dineInCart: {
        plusIcon: `${locationBaseURL}/cart/plusIcon.svg`,
        minusIcon: `${locationBaseURL}/cart/minusIcon.svg`,
      },
      loginWithoutOtp: {
        enrollEmployeeIcon: `${commonBaseURL}/loginWithoutOtp/enroll-employee-icon.svg`,
        employeeInfoIcon: `${commonBaseURL}/loginWithoutOtp/employee-info-icon.svg`,
        employeeIdIcon: `${commonBaseURL}/loginWithoutOtp/employee-id-icon.svg`,
      },
      stickyBanner: {
        promotionalBanner: `${locationBaseURL}/stickyBanner/sticky-Banner-mobile.svg`,
      },
      activeOrder : {
        arrowRight: `${commonBaseURL}/activeOrder/arrowRight.svg`,
        viewArrow: `${commonBaseURL}/activeOrder/viewArrow.svg`,
        domainIcon: `${commonBaseURL}/activeOrder/domainIcon.svg`
      }
    };
  };

  const imageList = useMemo(() => {
    if (platform && appConfig.locationId) {
      const commonBaseURL = `${S3_URL}/COMMON/${platform}/images`;
      const locationBaseURL = `${S3_URL}/${appConfig.locationId}/${platform}/images`;
      return fetchImageList(commonBaseURL, locationBaseURL);
    }
  }, [platform, appConfig.locationId]);

  return {
    imageList,
  };
};
